<template>
  <v-container class="pa-7">
    <p class="title font-weight-bold">Restart Progress</p>
    <v-divider class="my-10"></v-divider>
    <v-row>
      <v-col cols="12" sm="10" md="6" xl="4">
        <v-card
          class="shadow half-radius my-4"
          v-for="(item, index) in items"
          :key="item.name + index"
        >
          <v-container>
            <v-row align="center" class="px-5">
              <v-col class="pa-0">
                <span class="font-weight-bold">{{ item.name }}</span>
              </v-col>
              <v-btn
                depressed
                small
                class="white--text font-weight-medium text-capitalize pink-card"
                @click="restart(item.type)"
                >Restart Progress</v-btn
              >
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
    <v-divider class="my-10"></v-divider>
    <app-confirm-dialog v-model="dialog" @yes="onYes" :loading="loading"
      >Confirm to restart student progress?</app-confirm-dialog
    >
  </v-container>
</template>
<script>
import ConfirmDialog from "./ConfirmDialog.vue";
import { restartProgress } from "@/api/api";

export default {
  components: {
    appConfirmDialog: ConfirmDialog,
  },
  data() {
    return {
      loading: false,
      direction: "",
      dialog: false,
      items: [
        {
          name: "Live Lesson",
          type: "teach",
        },
        {
          name: "Lesson Practice",
          type: "practice",
        },
        {
          name: "Sentence Structure",
          type: "grammar",
        },
      ],
    };
  },
  methods: {
    restart(direction) {
      this.dialog = true;
      this.direction = direction;
    },
    async onYes() {
      this.loading = true;
      const response = await restartProgress(this.direction, {
        student: this.$store.getters.student.email,
        lesson: this.$store.getters["modules/currentLesson"].uuid,
      });
      if (response) {
        await this.$store.dispatch("progress/updateLesson", response.data.uuid);
      }
      this.loading = false;
      this.dialog = false;
    },
  },
};
</script>
<style scoped>
.pink-card {
  background: transparent linear-gradient(180deg, #ff2e7b 0%, #c71252 100%) 0% 0% no-repeat
    padding-box;
}
.big {
  font-size: 9.125rem;
  line-height: 1.2;
}
.stick {
  letter-spacing: -1rem;
}
.medium {
  font-size: 3.6875rem;
}
</style>
